module.exports = __webpack_public_path__ + "static/media/d8.b600a494.png";